import {
    WITHDRAW_PAGE_LOADED,
    WITHDRAW_PAGE_UNLOADED,
    WITHDRAW_STATUS_UPDATE,
    WITHDRAW_PAGE,
    ASYNC_START,
} from "../constants/actionTypes";

const defaultState = {
    results: { producers: [] },
    exports:"",
    pagination: { pageSize: 10, current: 1 },
    loading: false,
    fetchError: false,
    updateStatus: { id: -1, status: "", loading: false },
};
export default (state = { ...defaultState }, action) => {
    switch (action.type) {
        case WITHDRAW_PAGE_LOADED: {
            const pagination = action.pager;
            if (!action.error) {
                pagination.total = action.payload.total;
            }
            return {
                ...state,
                fetchError: !!action.error,
                results: action.payload,
                pagination,
                loading: false,
            };
        }
        case WITHDRAW_PAGE: {
            console.log(action.payload.withdraw)
            const exports = !action.payload.withdraw?"":action.payload.withdraw;
            return {
                ...state,
                exports,
            };
        }
        case WITHDRAW_STATUS_UPDATE: {
            const updateStatus = { ...state.updateStatus };
            updateStatus.id = action.error ? -1 : action.send.id;
            updateStatus.status = action.send.status;
            updateStatus.loading = false;
            return { ...state, updateStatus };
        }
        case ASYNC_START:
            if (action.subtype === WITHDRAW_PAGE_LOADED) {
                return { ...state, loading: true };
            }
            if (action.subtype === WITHDRAW_STATUS_UPDATE) {
                const updateStatus = { ...state.updateStatus };
                updateStatus.id = action.send.id;
                updateStatus.status = action.send.status;
                updateStatus.loading = true;
                return { ...state, updateStatus };
            }
            return state;
        case WITHDRAW_PAGE_UNLOADED:
            return { ...defaultState };
        default:
            return state;
    }
};
